'use strict';

import { getUserOrgIds } from 'Data/context/Organizations';
import { canUserViewAllCores } from 'Util';
import GenericTableData from './GenericTableData';

// Budget Module Event Bus. Handles all interactions with Budgets.
let BudgetData = GenericTableData.getTableDataBus('BUDGET', 'budgets');

BudgetData.getBudgetList = (opts) => {
  let where = {
    ...(opts?.where && { ...opts.where }),
  };
  if (
    !canUserViewAllCores() &&
    !Object.hasOwn(where, '*parent_organization_id')
  ) {
    where['*parent_organization_id'] = getUserOrgIds();
  }
  let options = {
    ...opts,
    where: where,
  };
  return BudgetData.getRecordList(options);
};

export default BudgetData;
